import VerifiedIcon from "../../../public/images/icons/verified.svg";

export const VerifiedBadge = ({ className }: any) => {
    return (
        <VerifiedIcon className={className || "w-[24px] h-[24px] sm:w-6 sm:h-6 absolute top-1 left-1 shadow shadow-md" } />
    )
}